'use strict';

angular.module('AdminSupervisorReviewControllers', [
    'ngAnimate',
    'ui.bootstrap',
    'mgcrea.ngStrap',
    'angularMoment',
    'pascalprecht.translate',
    'services.search',
    'services.businessSystem'
]);

